<template>
    <div class="layout">
        <div class="text">
            <p>文字內容｜廖婉馨、詹雅涵<br>
                視覺設計｜蔡詠全<br>
                網頁設計｜黃莘懿<br>
                特別感謝｜台北地方異聞工作室<br>
                &emsp;&emsp;&emsp;&emsp;｜奇異果文創<br>
                &emsp;&emsp;&emsp;&emsp;｜晨星出版社
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: `Copyright © 2022 民視新聞網路部 社群中心`,
        }
    },
}
</script>

<style scoped>
.layout {
    background-color: black;
    color: white;
    padding: 1rem;
    line-height: 3rem;
    font-size: 1.2rem;
}

.text {
    text-align: left;
    display: flex;
    justify-content: center;

}

p {
    line-height: 2.5rem;
}
</style>
